import { IDialog } from '@makyoapp/makyo-sdk/models/AppBuilder'
import { BuilderDialog } from '@makyoapp/makyo-common'

import { fromSdkActions, toSdkActions } from './BuilderActionAdapter'

export function fromSdkDialogList(dialogs: IDialog[]): BuilderDialog[] {
  return dialogs.map(fromSdkDialog)
}

export function fromSdkDialog(dialog: IDialog): BuilderDialog {
  return {
    id: dialog._id,
    name: dialog._Name,
    headline: dialog._HeadLine,
    headlineTypography: dialog._HeadLineTypography,
    content: dialog._Content,
    contentTypography: dialog._ContentTypography,
    showDivider: dialog._Divider._ShowDivider,
    icon: dialog._Icon._Icon?.value,
    showIcon: dialog._Icon._ShowIcon,
    showLeading: dialog._LeadingButton._Enable,
    leadingLabel: dialog._LeadingButton._Label ?? 'Cancel',
    leadingActions: dialog._LeadingButton._Actions
      ? fromSdkActions(dialog._LeadingButton._Actions, 'dialog-sequence')
      : [],
    leadingButtonColor: dialog._LeadingButton._Color,
    showTrailing: dialog._TrailingButton._Enabled,
    trailingLabel: dialog._TrailingButton._Label ?? 'Ok',
    trailingActions: dialog._TrailingButton._Actions
      ? fromSdkActions(dialog._TrailingButton._Actions, 'dialog-sequence')
      : [],
    trailingButtonColor: dialog._TrailingButton._Color,
    alignment: {
      titleAlignment: dialog._Alignment?._Title,
      contentAlignment: dialog._Alignment?._Content,
      footerAlignment: dialog._Alignment?._Footer,
      iconAlignment: dialog._Alignment?._Icon,
    },
    width: {
      phone: dialog._Width?.phone,
      tablet: dialog._Width?.tablet,
      desktop: dialog._Width?.desktop,
      tv: dialog._Width?.tv,
      'phone-landscape': dialog._Width?.['phone-landscape'],
      'tablet-landscape': dialog._Width?.['tablet-landscape'],
    },
  }
}

export function toSdkDialogList(dialogs: BuilderDialog[]): IDialog[] {
  return dialogs.map(toSdkDialog)
}

export function toSdkDialog(dialog: BuilderDialog): IDialog {
  return {
    _id: dialog.id,
    _Name: dialog.name,
    _HeadLine: dialog.headline ?? '',
    _HeadLineTypography: dialog.headlineTypography ?? '',
    _Content: dialog.content ?? '',
    _ContentTypography: dialog.contentTypography ?? '',
    _Icon: {
      _ShowIcon: dialog.showIcon,
      _Icon: {
        value: dialog.icon,
      },
    },
    _Divider: {
      _ShowDivider: dialog.showDivider,
    },
    _LeadingButton: {
      _Enable: dialog.showLeading,
      _Actions: toSdkActions(dialog.leadingActions, 'dialog-sequence'),
      _Label: dialog.leadingLabel,
      _Color: dialog.leadingButtonColor ?? '',
    },
    _TrailingButton: {
      _Enabled: dialog.showTrailing,
      _Actions: toSdkActions(dialog.trailingActions, 'dialog-sequence'),
      _Label: dialog.trailingLabel,
      _Color: dialog.trailingButtonColor ?? '',
    },
    _Data: {},
    _Alignment: {
      _Title: dialog.alignment?.titleAlignment ?? 'center',
      _Content: dialog.alignment?.contentAlignment ?? 'center',
      _Footer: dialog.alignment?.footerAlignment ?? 'center',
      _Icon: dialog.alignment?.iconAlignment ?? 'center',
    },
    _Width: {
      phone: dialog.width?.phone ?? '90%',
      tablet: dialog.width?.tablet ?? '350px',
      desktop: dialog.width?.desktop ?? '350px',
      tv: dialog.width?.tv ?? '350px',
      'phone-landscape': dialog.width?.['phone-landscape'] ?? '350px',
      'tablet-landscape': dialog.width?.['tablet-landscape'] ?? '350px',
    },
  }
}
